import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Spinner,
    Table,
    Tooltip,
} from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { useDispatch, useSelector } from "react-redux";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { getCompanyInvitationApi } from "../../service/api/companies/getCompanyInvitation";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import { setCurrentPage, setUserDetails } from "../../feature/userData/userData";
import acceptCompanyJoinRequestApi from "../../service/api/companies/acceptCompanyJoinRequest";
import acceptCompanyInvitationApi from "../../service/api/companies/acceptCompanyInvitation";
import { resendCompanyInvitationApi } from "../../service/api/companies/resendCompanyInvitation";
import { userById } from "../../service/api/user/userById";
import deleteCompanyInvitationApi from "../../service/api/companies/deleteCompanyInvitation";
import cancelCompanyInvitationApi from "../../service/api/companies/cancelCompanyInvitation";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";

const CompanyRequests = () => {
    const nevigate = useNavigate();
    const { role, permissionArr, impersonateFlag, inProgressServiceCount } = useSelector((state) => state.user);
    const permissionArray = permissionArr[0] || []
    const [basicModal, setBasicModal] = useState(false);
    const [initiColor, setInitiColor] = useState(true);
    const [sortingCol, setSortingCol] = useState(true);

    const [skeltonVal, setSkeltonVal] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [elements, setElements] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [deletingId, setDeletingId] = useState(false);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [columnName, setColumnName] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);
    const [handleToaster, setHandleToaster] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [resMessage, setResMessage] = useState("");
    const [firstCheck, setFirstCheck] = useState(false);
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
    const [userVerified, setUserVerified] = useState(0)
    const [impersonateModal, setImpersonateModal] = useState(false)
    const [impersonateId, setImpersonateId] = useState()

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);

    const [isExpandedUserId, setIsExpandedUserId] = useState('');

    const [companyInvitationObj, setCompanyInvitationObj] = useState({})

    const [companyInvitationId, setCompanyInvitationId] = useState('')

    const [proAcceptCompanyReqModal, setProAcceptCompanyReqModal] = useState(false)
    const handleOpenProAcceptCompanyReqModal = () => {
        setProAcceptCompanyReqModal(true)
    }

    const handleCloseProAcceptCompanyReqModal = () => {
        setProAcceptCompanyReqModal(false);
        setCompanyInvitationObj({})
    }

    const [companyAdminApproveModal, setCompanyAdminApproveModal] = useState(false)
    const handleOpenCompanyAdminApproveModal = () => {
        setCompanyAdminApproveModal(true)
    }

    const handleCloseCompanyAdminApproveModal = () => {
        setCompanyAdminApproveModal(false);
        setCompanyInvitationObj({})
    }



    const percentage = 70;

    const tooltipDelete = (
        <Tooltip id="tooltip">
            <strong>Delete</strong>
        </Tooltip>
    );
    const tooltipEdit = (
        <Tooltip id="tooltip">
            <strong>Edit</strong>
        </Tooltip>
    );
    const tooltipVerify = (
        <Tooltip id="tooltip">
            <strong>Verify</strong>
        </Tooltip>
    );

    useEffect(() => {
        dispatch(setCurrentPage("Invitations"));
    }, []);


    // With new logic
    const [expandedRow, setExpandedRow] = useState(null);

    const handleToggle = (rowIndex) => {
        if (rowIndex === expandedRow) {
            setExpandedRow(null);
        } else {
            setExpandedRow(rowIndex);
        }
    };

    // Modal triggers for the service requests details
    const [show, setShow] = useState(false);

    // Modal triggers for the service requests details
    const [showCallDetails, setShowCallDetails] = useState(false);

    const handleCloseCallDetails = () => setShowCallDetails(false);
    const handleShowCallDetails = (e) => {
        e.stopPropagation();
        setShowCallDetails(true);
    };





    // Dummy call check for toaster

    const getCallHistoryDetails = (res) => {

        // const newElements = [...elements, ...res.data];
        // const uniqueElements = Array.from(
        //   new Set(newElements.map(JSON.stringify))
        // ).map(JSON.parse);


        setElements(res.data);
        setTotalNoRecord(res.total_count);


        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }

    };

    function onLoadData() {

        setSkeltonVal(true);
        setCustomeSkeletonLoading(true);

        const data = new FormData();
        data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("pagination_flag", 1);
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        dispatch(
            getCompanyInvitationApi(data, (res) => {
                setSkeltonVal(false);
                setElements(res.data.data);
                getCallHistoryDetails(res.data);
                setCustomeSkeletonLoading(false);
                setTotalNoRecord(res.data.total_count);
                if (res.data.total_count % pageSize === 0) {
                    setTotalPage(parseInt(res.data.total_count / pageSize));
                } else {
                    setTotalPage(parseInt(res.data.total_count / pageSize + 1));
                }

            }, (err) => {
                setCustomeSkeletonLoading(true);
            })
        );

        return;
    }

    const handleColumnName = (name) => {
        setSortingCol(false);
        setColumnName(name);

        if (sortByValue === "ASC") {
            setSortByValue("DESC");
        }
        if (sortByValue === "DESC") {
            setSortByValue("ASC");
        }
    };

    const handleOrderValue = (order) => {
        setSortByValue(order);
    };

    const handleSearch = (e) => {
        setPage(1);
        const ele = []
        setElements(ele);
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
            setColumnName('')
        }
        setSearchValue(e.target.value)
    };

    const handleChangeRowsPerPage = (e) => {
        // console.log(e)
        setSearchValue("");
        setPage(1);
        setPageSize(e.target.value);
    };

    const onChangePage = (e, p) => {
        // setPage(p);
        setPage(e);
    };

    useEffect(() => {
        onLoadData();
    }, [sortByValue, pageSize, page, columnName, filtreValue]);

    useEffect(() => {
        // if (searchValue.trim().length > 2) {
        //   const ele = [];
        //   setPage(1);
        //   setElements(ele);
        //   setFlag(true);
        //   const timeOutId = setTimeout(onLoadSearch, 1000);
        //   return () => clearTimeout(timeOutId);
        // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
        //   if (flag) {
        //     onLoadData();
        //   }
        // }

        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(onLoadSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValue]);

    function onLoadSearch() {
        setSkeltonVal(true);
        var data = {
            user_id_ids: localStorage.getItem("user_id"),
            pagination_flag: 1,
            page_index: 1,
            page_size: pageSize,
            sorting_order: sortByValue,
            sorting_column_name: "",
            search_area: searchValue,
        };
        dispatch(
            getCompanyInvitationApi(data, (res) => {
                setSkeltonVal(false);
                getCallHistoryDetails(res.data);
                // setElements(res.data.data);
                // setTotalNoRecord(res.data.total_count);
                // if (res.data.total_count % pageSize === 0) {
                //   setTotalPage(parseInt(res.data.total_count / pageSize));
                // } else {
                //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
                // }

            })
        );
    }

    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        setPage(1);
        setElements(ele);
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }

    const searchAreaVal = (e) => {
        // setSearchArea(e.target.value)
        // if (searchArea.trim().length >= 2) {
        //     onChangePage(1)
        // }

        setSearchValue(e.target.value)
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
        }
    }

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const [invitationLoading, setInvitationLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [responceMsg, setResponceMsg] = useState("");

    function handleGetUserById(e) {
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            role_id_int: localStorage.getItem("roleId"),
            user_impersonate_flag: 0,
        };

        dispatch(
            userById(
                details,
                (res) => {
                    dispatch(setUserDetails(res.data.data));
                    localStorage.setItem("triggerFlag", res.data.data.is_available_ysn);
                    navigate("/dashboard");
                },
                (err) => { }
            )
        );
    }

    const handleProAcceptCompanyRequest = () => {

        let data = new FormData();
        data.append('company_invitation_token', companyInvitationObj?.company_invitation_code);

        setInvitationLoading(true);

        // dispatch(updateBackDropLoaderWithoutStateTrue());

        dispatch(acceptCompanyInvitationApi(data, (res) => {

            console.log(res, "res acceptCompanyInvitationApi");
            setSuccessMsg(res?.data?.message);
            setInvitationLoading(false);
            handleCloseProAcceptCompanyReqModal();
            onLoadData();
            handleGetUserById();

        }, (err) => {
            console.log(err, "err acceptCompanyInvitationApi");
            // setCustomLoading(false);
            setInvitationLoading(false);
            setResponceMsg(err?.data?.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);

        }))
    }

    const handleCompanyAdminApproveRequest = () => {
        let data = new FormData();
        data.append('company_invitation_token', companyInvitationObj?.company_invitation_code);

        setInvitationLoading(true);

        dispatch(acceptCompanyJoinRequestApi(data, (res) => {

            console.log(res, "res acceptCompanyInvitationApi");
            setSuccessMsg(res?.data?.message);
            setInvitationLoading(false);
            handleCloseCompanyAdminApproveModal();
            onLoadData();

        }, (err) => {
            console.log(err, "err acceptCompanyInvitationApi");
            // setCustomLoading(false);

            setInvitationLoading(false);

            setResponceMsg(err?.data?.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    const handleResendCompanyInvitation = (invitationId) => {
        setInvitationLoading(true);
        let formData = new FormData();
        formData.append("invitation_id_ids", invitationId);

        dispatch(
            resendCompanyInvitationApi(
                formData,
                (res) => {
                    setResponceMsg(res.data.message);
                    setToasterType("success");
                    setInvitationLoading(false);
                    onLoadData();
                    setCompanyInvitationId("");

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 4000);
                },
                (err) => {
                    setResponceMsg(err.data.message);
                    setToasterType("error");
                    setHandleToaster(true);
                    setInvitationLoading(false);
                    setCompanyInvitationId("");

                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );

    }

    const backToPrevious = () => {
        navigate(-1)
    }

    // Delete invitation functions
    const [deleteInvitationModalTrigger, setDeleteInvitationModalTrigger] = useState(false);
    const handleOpenDeleteInvitationModal = (invitationId) => {
        setDeleteInvitationModalTrigger(true);
        setCompanyInvitationId(invitationId);
    }

    const handleCloseDeleteInvitationModal = () => {
        setDeleteInvitationModalTrigger(false);
        setCompanyInvitationId('');
    }
    const handleDeleteCompanyInvitationFn = () => {
        setInvitationLoading(true);
        let data = {
            invitation_id_ids: companyInvitationId
        }

        dispatch(deleteCompanyInvitationApi(data, (res) => {
            setResMessage(res?.data?.message);
            setInvitationLoading(false);
            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 5000);
            handleCloseDeleteInvitationModal();
            onLoadData();
        }, (err) => {
            setResMessage(err?.data?.message);
            setInvitationLoading(false);
            setToasterType("error");
            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    // Cancel invitations functions
    const [cancelInvitationModalTrigger, setCancelInvitationModalTrigger] = useState(false);
    const handleOpenCancelInvitationModal = (invitationId) => {
        setCancelInvitationModalTrigger(true);
        setCompanyInvitationId(invitationId);
    }

    const handleCloseCancelInvitationModal = () => {
        setCancelInvitationModalTrigger(false);
        setCompanyInvitationId('');
    }

    const handleCancelCompanyInvitationFn = () => {
        setInvitationLoading(true);
        let data = {
            invitation_id_ids: companyInvitationId
        }

        dispatch(cancelCompanyInvitationApi(data, (res) => {
            setResMessage(res?.data?.message);
            setInvitationLoading(false);
            // setHandleToaster(true);
            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 5000);
            handleCloseCancelInvitationModal();
            onLoadData();
        }, (err) => {
            setResMessage(err?.data?.message);
            setInvitationLoading(false);
            setToasterType("error");
            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    return (
        <>
            {/* New Admin dashboard */}
            <div className="row mx-3 mb-5" style={{}}>
                <div className="col-12 px-0">

                    {/* <div className="row mx-0 p-3">
                        <div className="col-12 px-0 ps-2 d-flex align-item-center justify-content-start">
                            <span className="fs-4 fw-bold text-black">
                                {`${(permissionArray.includes("VIEW COMPANY USERS")) ? "Join requests" : "Company invitations"}`}
                            </span>
                        </div>
                    </div> */}

                    <div className="d-flex">
                        <h4 onClick={backToPrevious} className='back-to-admin-btn'>
                            <i style={{ marginRight: '10px', }} className="bi bi-arrow-left "></i>
                            {"Company invitations"}
                        </h4>
                    </div>

                    <div className='my-3'>
                        <PaginationAndSearching
                            handleSearch={searchAreaVal}
                            // searchValue={searchArea}
                            searchValue={searchValue}
                            defaultValue={pageSize}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            totalCount={totalPage}
                            onChange={onChangePage}
                        />
                    </div>

                    <Table responsive>

                        <thead>
                            <tr className='text-black bg-light'>
                                <th
                                    style={{ fontWeight: '700' }}
                                >
                                    {`Actions`}
                                </th>

                                {/* {(permissionArray.includes("VIEW COMPANY USERS")) &&
                                    <th
                                        style={{ fontWeight: '700' }}
                                    >
                                        {`Role`}
                                    </th>
                                } */}

                                <th
                                    className=''
                                    style={{ fontWeight: '700' }}
                                >
                                    {`Description`}
                                </th>

                                {/* <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("email_chr") }}
                                >
                                    {`Email`}
                                    <span className="ml-1">
                                        {columnName === 'email_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th> */}

                                {/* <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("phone_number_int") }}
                                >
                                    {`Phone`}
                                    <span className="ml-1">
                                        {columnName === 'phone_number_int' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th> */}

                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("company_code_chr") }}
                                >
                                    {`Company code`}
                                    {/* <span className="ml-1">
                                        {columnName === 'company_code_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}
                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>

                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("created_date_dtm") }}
                                >
                                    {`Created on`}
                                    <span className="ml-1">
                                        {columnName === 'created_date_dtm' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}
                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {customeSkeletonLoading ?
                                <SkeletonTableRow cols={4} /> :
                                <>
                                    {elements?.length > 0 ?
                                        <>
                                            {elements?.map((element, index) => {
                                                return (
                                                    <>
                                                        <tr
                                                            className={`notification-rows font-w700 }`}
                                                            key={index}
                                                            style={{ cursor: 'default' }}
                                                        >
                                                            <td className="d-flex align-items-center justify-content-center">

                                                                {(permissionArray.includes("VIEW COMPANY USERS")) &&
                                                                    <>
                                                                        {element?.invitation_type_int == 2 ?
                                                                            <Button
                                                                                onClick={() => {
                                                                                    handleOpenCompanyAdminApproveModal()
                                                                                    setCompanyInvitationObj(element)
                                                                                }}
                                                                                loadingMessage={"LOADING..."}
                                                                                // isLoading={statusUpdateLoaderCust}
                                                                                style={{
                                                                                    width: '120px',
                                                                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                    border: 'none',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                    borderRadius: '4px',
                                                                                    pointerEvents: element?.status_int == 0 ? 'auto' : 'none',
                                                                                    opacity: element?.status_int == 0 ? '1' : '0.5',
                                                                                    padding: '6px 12px',
                                                                                    fontWeight: '600'
                                                                                }}
                                                                            >
                                                                                {
                                                                                    element?.status_int == 0 ? "APPROVE" : "APPROVED"
                                                                                }
                                                                            </Button> :
                                                                            <Button
                                                                                onClick={() => {
                                                                                    // handleOpenCompanyAdminApproveModal()
                                                                                    // setCompanyInvitationObj(element)
                                                                                    handleResendCompanyInvitation(element?.invitation_id_ids)
                                                                                    setCompanyInvitationId(element?.invitation_id_ids)
                                                                                }}
                                                                                loadingMessage={"SENDING..."}
                                                                                // isLoading={statusUpdateLoaderCust}
                                                                                style={{
                                                                                    width: '120px',
                                                                                    background: element?.status_int == 0 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    border: 'none',
                                                                                    borderRadius: '4px',
                                                                                    pointerEvents: ((element?.status_int == 0) || (invitationLoading && companyInvitationId == element?.invitation_id_ids)) ? 'auto' : 'none',
                                                                                    opacity: ((element?.status_int == 0) || (invitationLoading && companyInvitationId == element?.invitation_id_ids)) ? '1' : '0.5',
                                                                                    padding: '6px 12px',
                                                                                    fontWeight: '600'
                                                                                }}
                                                                            >
                                                                                {invitationLoading && companyInvitationId == element?.invitation_id_ids ?
                                                                                    <Spinner animation="border" size="sm" /> :
                                                                                    <>
                                                                                        {element?.status_int == 0 ? "RESEND" : "ACCEPTED"}
                                                                                    </>
                                                                                }
                                                                            </Button>}
                                                                    </>
                                                                }

                                                                {(permissionArray.includes("VIEW OPEN SERVICE REQUESTS")) &&
                                                                    <>
                                                                        {element?.invitation_type_int == 1 ?
                                                                            <>
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        handleOpenProAcceptCompanyReqModal()
                                                                                        setCompanyInvitationObj(element)
                                                                                    }}
                                                                                    loadingMessage={"LOADING..."}
                                                                                    // isLoading={statusUpdateLoaderCust}
                                                                                    style={{
                                                                                        width: '120px',
                                                                                        background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                        border: 'none',
                                                                                        boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                        borderRadius: '4px',
                                                                                        pointerEvents: (((element?.status_int == 0) || (element?.status_int !== 2))) ? 'auto' : 'none',
                                                                                        opacity: (((element?.status_int == 0) || (element?.status_int !== 2))) ? '1' : '0.5',
                                                                                        padding: '6px 12px',
                                                                                        fontWeight: '600'
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        element?.status_int == 0 ? "ACCEPT" : element?.status_int == 1 ? "ACCEPTED" : "CANCELLED"
                                                                                    }
                                                                                </Button>
                                                                            </> :
                                                                            <Button
                                                                                onClick={() => {
                                                                                    // handleOpenCompanyAdminApproveModal()
                                                                                    // setCompanyInvitationObj(element)
                                                                                    handleResendCompanyInvitation(element?.invitation_id_ids)
                                                                                    setCompanyInvitationId(element?.invitation_id_ids)
                                                                                }}
                                                                                loadingMessage={"SENDING..."}
                                                                                // isLoading={statusUpdateLoaderCust}
                                                                                style={{
                                                                                    width: '120px',
                                                                                    background: element?.status_int == 0 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    border: 'none',
                                                                                    borderRadius: '4px',
                                                                                    pointerEvents: (((element?.status_int == 0) || (element?.status_int == 2)) || (invitationLoading && companyInvitationId == element?.invitation_id_ids)) ? 'auto' : 'none',
                                                                                    opacity: (((element?.status_int == 0) || (element?.status_int == 2)) || (invitationLoading && companyInvitationId == element?.invitation_id_ids)) ? '1' : '0.5',
                                                                                    padding: '6px 12px',
                                                                                    fontWeight: '600'
                                                                                }}
                                                                            >
                                                                                {invitationLoading && companyInvitationId == element?.invitation_id_ids ?
                                                                                    <Spinner animation="border" size="sm" /> :
                                                                                    <>
                                                                                        {((element?.status_int == 0) || (element?.status_int == 2)) ? "RESEND" : "ACCEPTED"}
                                                                                    </>
                                                                                }
                                                                            </Button>
                                                                        }

                                                                        {(element?.status_int == 0) && (element?.sent_to_id_lng == localStorage.getItem("user_id")) &&
                                                                            <>
                                                                                <div className="tooltipCustom">
                                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Cancel invitation"}</span>
                                                                                    <span
                                                                                        className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.user_id_ids === isExpandedUserId ? '' : 'text-danger'} `}
                                                                                        style={{ height: '35px', width: '35px' }}
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            handleOpenCancelInvitationModal(element.invitation_id_ids);
                                                                                        }}
                                                                                    >
                                                                                        <i className="bi bi-x-lg"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        }


                                                                        {element?.created_by_chr == localStorage.getItem("user_id") && ((element?.status_int == 0) || (element?.status_int == 2)) &&
                                                                            <div className="tooltipCustom">
                                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete invitation"}</span>
                                                                                <span
                                                                                    className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.user_id_ids === isExpandedUserId ? '' : 'text-danger'} `}
                                                                                    style={{ height: '35px', width: '35px' }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleOpenDeleteInvitationModal(element.invitation_id_ids);
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-trash3"></i>
                                                                                </span>
                                                                            </div>
                                                                        }

                                                                    </>
                                                                }
                                                            </td>

                                                            {/* {(permissionArray.includes("VIEW COMPANY USERS")) &&
                                                                <td>
                                                                    <span
                                                                        className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                        style={{
                                                                            background: "rgba(79, 93, 116, 1)",
                                                                        }}>
                                                                        {`${element?.role_display_name_chr}`}
                                                                    </span>
                                                                </td>
                                                            } */}

                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    {(permissionArray.includes("VIEW COMPANY USERS")) &&
                                                                        <>
                                                                            {element?.invitation_type_int == 2 ?
                                                                                <span className="w-space-no"> {`${element.sender_first_name ? element.sender_first_name : "user"} has requested to join ${element.company_name_chr} as ${element?.role_display_name_chr}`} </span> :
                                                                                <span className="w-space-no">{`You have sent request to ${element?.first_name_chr ? `${element?.first_name_chr} ${element?.last_name_chr}` : element?.email_chr ? element?.email_chr : element.phone_number_int == null ? ('-') : `${element?.phone_number_int}`} `} </span>
                                                                            }
                                                                            {/* <span className="w-space-no">{`${element?.company_name_chr} has sent you a request to join as ${element.role_display_name_chr}`} </span> */}
                                                                        </>
                                                                    }

                                                                    {(permissionArray.includes("VIEW OPEN SERVICE REQUESTS")) &&
                                                                        <>
                                                                            {element?.invitation_type_int == 1 ?
                                                                                <span className="w-space-no">{`${element?.company_name_chr} has sent you a request to join as ${element.role_display_name_chr} `} </span> :
                                                                                <span className="w-space-no"> {`You have sent request to join ${element?.company_name_chr}`} </span>
                                                                            }
                                                                            {/* <span className="w-space-no">{`${element?.company_name_chr} has sent you a request to join as ${element.role_display_name_chr}`} </span> */}
                                                                        </>
                                                                    }
                                                                </div>
                                                            </td>

                                                            {/* <td>
                                                                <span className="w-space-no">{element.email_chr ? element.email_chr : "-"}</span>
                                                            </td> */}

                                                            {/* <td>
                                                                <span>{element.phone_number_int == null ? ('-') : <InternationalPhoneFormat countryCode={element.country_phone_code_chr} phoneNumber={`${element.phone_number_int}`} />}</span>
                                                            </td> */}

                                                            <td>
                                                                <span className="">{`${element?.company_code_chr ? element?.company_code_chr : '-'}`}</span>
                                                            </td>

                                                            <td>
                                                                <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span>
                                                            </td>
                                                        </tr>

                                                    </>
                                                )
                                            })}</> :
                                        <tr>
                                            <td colSpan="8">No Records Found</td>
                                        </tr>
                                    }
                                </>
                            }
                        </tbody>
                    </Table>
                </div>
            </div>

            {/* Modal for accept company request by pro */}
            <Modal className='fade' centered show={proAcceptCompanyReqModal}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {"Accept company request"}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseProAcceptCompanyReqModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                {/* <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Do you `}
                                        </span>
                                    </div>
                                </div> */}

                                <>
                                    <div className='fs-4 font-w600 text-black text-center mb-5'>
                                        <span>
                                            {`${companyInvitationObj?.company_name_chr} has sent you a request to join as ${companyInvitationObj.role_display_name_chr}`}
                                        </span>
                                    </div>

                                    <div className='fs-5 font-w500 d-flex mt-3'>
                                        <div className='d-flex me-2' style={{ color: '#4e5d74', width: '115px' }}>
                                            <span>
                                                <i className="fa fa-info-circle me-2" ></i>
                                            </span>
                                            <span className='font-w600'>{`Note:`}</span>
                                        </div>
                                        <div>
                                            <span>{`Your current subscription will be cancelled after joining the company`}</span>
                                        </div>
                                    </div>

                                    <div className='row mt-5 w-100 '>

                                        <div className='col-6 pe-2 mt-2'>
                                            <PrimaryButton
                                                buttonName={`CANCEL`}
                                                onClick={(e) => { handleCloseProAcceptCompanyReqModal() }}
                                                loadingMessage={"Saving..."}
                                                isLoading={false}
                                                style={{
                                                    width: '100%',
                                                    background: '#4e5d74',
                                                    border: 'none',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>

                                        <div
                                            className='col-6 ps-2 mt-2'
                                            title={`${inProgressServiceCount > 0 ? 'Please close your active service requests first, and then you will be able to join the company.' : ''}`}
                                        >
                                            <PrimaryButton
                                                buttonName={`ACCEPT`}
                                                onClick={(e) => { handleProAcceptCompanyRequest() }}
                                                loadingMessage={"ACCEPTING..."}
                                                isLoading={invitationLoading}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                    fontWeight: '600',
                                                    opacity: inProgressServiceCount == 0 ? 1 : 0.5,
                                                    pointerEvents: inProgressServiceCount == 0 ? 'all' : 'none',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            {/* Modal for accept pro in company by Company Admin */}
            < Modal className='fade' centered show={companyAdminApproveModal} >
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {"Approve request"}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseCompanyAdminApproveModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                {/* <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Do you `}
                                        </span>
                                    </div>
                                </div> */}

                                <>
                                    <div className='fs-4 font-w600 text-black text-center mb-5'>
                                        <span>
                                            {`${companyInvitationObj.sender_first_name ? companyInvitationObj.sender_first_name : "User"} has requested to join ${companyInvitationObj.company_name_chr} as ${companyInvitationObj?.role_display_name_chr}`}
                                        </span>
                                    </div>


                                    <div className='row mt-5 w-100 '>

                                        <div className='col-6 pe-2 mt-2'>
                                            <PrimaryButton
                                                buttonName={`CANCEL`}
                                                onClick={(e) => { handleCloseCompanyAdminApproveModal() }}
                                                loadingMessage={"Saving..."}
                                                isLoading={false}
                                                style={{
                                                    width: '100%',
                                                    background: '#4e5d74',
                                                    border: 'none',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>

                                        <div className='col-6 ps-2 mt-2'>
                                            <PrimaryButton
                                                buttonName={`APPROVE`}
                                                onClick={(e) => { handleCompanyAdminApproveRequest() }}
                                                loadingMessage={"ACCEPTING..."}
                                                isLoading={invitationLoading}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                    fontWeight: '600',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            {deleteInvitationModalTrigger && <AcceptRejectModal
                text={"Are you sure you want to delete this invitation?"}
                modalStatus={deleteInvitationModalTrigger}
                onClickAccept={handleDeleteCompanyInvitationFn}
                onClickReject={() => handleCloseDeleteInvitationModal()}
                loaderActive={invitationLoading}
                loadingButtonName={"DELETING..."}
            />}

            {
                cancelInvitationModalTrigger && <AcceptRejectModal
                    text={"Are you sure you want to cancel this invitation?"}
                    modalStatus={cancelInvitationModalTrigger}
                    onClickAccept={handleCancelCompanyInvitationFn}
                    onClickReject={() => handleCloseCancelInvitationModal()}
                    loaderActive={invitationLoading}
                    loadingButtonName={"CANCELING..."}
                />
            }

            {
                handleToaster && (
                    <ResponceToaster toasterType={toasterType} message={responceMsg} />
                )
            }



        </>
    );
};

export default CompanyRequests;
